import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { IMessageBoxParams } from "../../../../../common/MessageBox";
import {
  getModelProperty,
  ModelProperty,
} from "../../../../../webapi/service/getModelProperty";
import AuthService from "../../../../../common/AuthService";
import BackButton from "../../../common/BackButton";
import "../../../../main.css";
import "./model.css";

export interface IProps extends WithTranslation {
  /**
   * 認証サービス
   */
  authService?: AuthService;
  /**
   * プロジェクトID
   */
  projectid: string;
  /**
   * 戻るボタンが押された場合に呼び出されます
   */
  onBack: () => void;
  /**
   * ローディング画面の表示非表示を切り替えます
   * @param loading - ローディング画面を表示する場合はtrue
   */
  onLoading: (loading: boolean) => void;
  /**
   * メッセージBoxを表示します
   * @param params - メッセージBoxパラメータ
   */
  showMessage: (params: IMessageBoxParams) => void;
  /**
   * 通信エラーが発生した場合に呼び出します
   * @param id - メッセージID
   * @param status - httpステータスコード
   */
  onCommunicationError: (
    id: string | undefined,
    status: number | undefined
  ) => void;
}

interface IState {
  /**
   * 診断モデルプロパティ一覧
   */
  files: ModelProperty[];
  /**
   * 診断モデルチャネル一覧
   */
  channels: string[];
}

class ModelPropertyPanel extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = { files: [], channels: [] };
  }

  componentDidMount() {
    const { authService, projectid, onLoading, onCommunicationError } =
      this.props;
    onLoading(true);
    getModelProperty({
      authService: authService,
      projectid: projectid,
      success: (files, channels) => {
        onLoading(false);
        this.setState({ files: files, channels: channels });
      },
      fail: (id, status) => {
        onCommunicationError(id, status);
      },
    });
  }

  createFileTsable() {
    const { t } = this.props;
    const { files } = this.state;
    const tr: JSX.Element[] = [];
    files.forEach((file, i) => {
      tr.push(
        <tr key={i}>
          <td>{file.filename}</td>
          <td>{file.label}</td>
        </tr>
      );
    });
    return (
      <table>
        <thead>
          <tr>
            <th>{t("model_property_list_filename")}</th>
            <th>{t("model_property_list_label")}</th>
          </tr>
        </thead>
        <tbody>{tr}</tbody>
      </table>
    );
  }

  createChannelsTable() {
    const { t } = this.props;
    const { channels } = this.state;
    const tr: JSX.Element[] = [];
    channels.forEach((channel, i) => {
      tr.push(
        <tr key={i}>
          <td>{channel}</td>
        </tr>
      );
    });
    return (
      <table>
        <thead>
          <tr>
            <th>{t("model_property_list_channel")}</th>
          </tr>
        </thead>
        <tbody>{tr}</tbody>
      </table>
    );
  }

  render() {
    const { onBack, t } = this.props;
    const filestable = this.createFileTsable();
    const channelstable = this.createChannelsTable();
    return (
      <div className="mainspace">
        <div className="mainspace-title">
          <h3>{t("model_property")}</h3>
        </div>
        <div className="mainspace-toolbar">
          <BackButton onClick={onBack} />
        </div>
        <div className="property-list">
          <div className="files">{filestable}</div>
          <div className="channels">{channelstable}</div>
        </div>
      </div>
    );
  }
}

/**
 * モデルプロパティ画面
 */
export default withTranslation()(ModelPropertyPanel);
